/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */

const ModalBody = (props) => (
  <div className="modal-body">
    { props.children }
  </div>
);

export default ModalBody;
